import { Flex, Text, useMantineTheme } from '@mantine/core';
import { AuditAction } from '@dealstack/shared/lib/generated';
import { BasicMantineTable } from '@dealstack/frontend/shared/components/BasicMantineTable/BasicMantineTable';
import { getAuditListColumns } from '@dealstack/frontend/shared/components/Audit/AuditLayout/auditTableColumns.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import {
	Dot,
	StyledContainer,
	StyledHeader,
	StyledTableWrapper,
} from '@dealstack/frontend/shared/components/Audit/AuditLayout/styled.ts';
import { TransformedAuditData } from '@dealstack/frontend/shared/components/Audit/types.ts';

interface Props {
	title: string;
	/** Preformatted — callers differ on the date format. */
	timestamp: string;
	/** Picks the column set: before/after for an update, a single value column otherwise. */
	action: AuditAction;
	data: TransformedAuditData[];
	dataTestId?: string;
}

/** What one audit entry changed, as a field-by-field table. */
export const AuditDetailView = ({ title, timestamp, action, data, dataTestId }: Props) => {
	const tCapManage = useTranslationCapManage();
	const theme = useMantineTheme();

	const columns = getAuditListColumns({ tCapManage, auditAction: action });

	return (
		<StyledContainer data-testid={dataTestId}>
			<StyledHeader>
				<Flex justify="start" align="center" gap="0.5rem">
					<Text fw={600} size="lg">
						{title}
					</Text>
					<Dot color={theme.colors.gray[4]} />
					<Text>{timestamp}</Text>
				</Flex>
			</StyledHeader>

			<StyledTableWrapper>
				<BasicMantineTable
					columns={columns}
					data={data}
					hideTopToolbar={true}
					enableColumnResizing={true}
				/>
			</StyledTableWrapper>
		</StyledContainer>
	);
};
